import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "12px",
    "margin-bottom": "16px"
  }
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "white-space": "nowrap",
    "color": "#303133"
  }
}, "统一进货价:", -1);

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_4 = {
  style: {
    "font-weight": "500",
    "color": "#303133",
    "margin-bottom": "12px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "32px"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "white-space": "nowrap",
    "color": "#606266"
  }
}, "业务员进货价:", -1);

const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "white-space": "nowrap",
    "color": "#606266"
  }
}, "负责人进货价:", -1);

const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定");

import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { PRE_PAYMENT_PRICE_LEVELS, PRE_PAYMENT_PRICE_FIELDS, createEmptyPrePaymentPrices, hasCompletePrePaymentPrices, pickPrePaymentPrices } from './pre-payment-price-constants';
export default {
  name: 'pre-payment-price-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    priceData: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    const unifiedPrice = ref();
    const form = reactive(createEmptyPrePaymentPrices());
    watch(() => props.modelValue, val => {
      if (!val) return;
      Object.assign(form, createEmptyPrePaymentPrices(), pickPrePaymentPrices(props.priceData));
      unifiedPrice.value = undefined;
    });

    function applyUnifiedPrice() {
      const price = Number(unifiedPrice.value);

      if (!price || price <= 0) {
        ElMessage.warning('请填写统一进货价');
        return;
      }

      PRE_PAYMENT_PRICE_FIELDS.forEach(field => {
        form[field] = price;
      });
    }

    function submit() {
      if (!hasCompletePrePaymentPrices(form)) {
        ElMessage.warning('请维护全部团队层级进货价');
        return;
      }

      emit('success', pickPrePaymentPrices(form));
      visible.value = false;
    }

    function handleClosed() {
      Object.assign(form, createEmptyPrePaymentPrices());
      unifiedPrice.value = undefined;
    }

    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "编辑套餐预付价",
        width: "700px",
        "close-on-click-modal": false,
        onClosed: handleClosed
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), !__props.disabled ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_input_number, {
          modelValue: unifiedPrice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => unifiedPrice.value = $event),
          min: 0.01,
          max: 999999999,
          precision: 2,
          step: 0.01,
          "controls-position": "right",
          disabled: __props.disabled,
          style: {
            "width": "180px"
          }
        }, null, 8, ["modelValue", "min", "step", "disabled"]), _createVNode(_component_el_button, {
          type: "primary",
          disabled: __props.disabled,
          onClick: applyUnifiedPrice
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }, 8, ["disabled"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRE_PAYMENT_PRICE_LEVELS), level => {
          return _openBlock(), _createElementBlock("div", {
            key: level.label,
            style: {
              "border": "1px solid #ebeef5",
              "border-radius": "4px",
              "padding": "14px 20px",
              "margin-bottom": "12px"
            }
          }, [_createElementVNode("div", _hoisted_4, _toDisplayString(level.label), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input_number, {
            modelValue: form[level.salesman],
            "onUpdate:modelValue": $event => form[level.salesman] = $event,
            min: 0.01,
            max: 999999999,
            precision: 2,
            step: 0.01,
            "controls-position": "right",
            disabled: __props.disabled,
            style: {
              "width": "180px"
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "step", "disabled"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_input_number, {
            modelValue: form[level.owner],
            "onUpdate:modelValue": $event => form[level.owner] = $event,
            min: 0.01,
            max: 999999999,
            precision: 2,
            step: 0.01,
            "controls-position": "right",
            disabled: __props.disabled,
            style: {
              "width": "180px"
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "step", "disabled"])])])]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};